import { jsx as _jsx } from "react/jsx-runtime";
import { RichText } from '@atlassiansox/bxp-content-framework';
import { useMember } from '../../../../components';
import { Root, LoginText } from './DetailsPanel.styles';
import { SelectTeamMessage } from './components';
export function DetailsPanel({ isOpen, loginText, selectTeamText, noTeamText }) {
    const member = useMember();
    if (isOpen) {
        switch (member.status) {
            case 'resolved':
                const { organizations = [], id } = member.value;
                const memberOrganizations = organizations.filter((organization) => {
                    var _a;
                    return (_a = organization.memberships) === null || _a === void 0 ? void 0 : _a.some((membership) => membership.idMember === id);
                });
                if (memberOrganizations.length > 0) {
                    return (_jsx(Root, { children: _jsx(SelectTeamMessage, { text: selectTeamText, organizations: memberOrganizations }, void 0) }, void 0));
                }
                else {
                    return (_jsx(Root, { children: _jsx(RichText, { document: noTeamText }, void 0) }, void 0));
                }
            case 'rejected':
                return (_jsx(Root, { children: _jsx(LoginText, { document: loginText }, void 0) }, void 0));
            case 'pending':
                return null;
        }
    }
    else {
        return null;
    }
}
//# sourceMappingURL=DetailsPanel.js.map